<template>

    <div class="divide-y divide-gray-200 website::admin-websitePages-createEdit-moduleEditor-Gallery">

        <Toolbar
            title="Module kiezen"
            instruction="Kies en configueer een module voor deze pagina."
        />

        <div class="flex px-5 py-10 sm:px-10">

            <div class="w-1/3 pr-0 -space-y-px bg-white rounded-md selector">

                <a v-for="(moduleData, moduleId, key) in modulesData"
                   href="#"
                   class="relative flex items-center p-4 border border-gray-200"
                   :class="{ active: moduleId === currentModuleId, 'rounded-t-md': key === 0, 'rounded-b-md': key === Object.keys(modulesData).length - 1 }"
                   @click="onModuleClick($event, moduleId)">

                    <div class="grid w-full grid-cols-10">

                        <div class="flex items-center justify-center col-span-1">
                            <i class="text-2xl"
                               :class="moduleData.meta.icon">
                            </i>
                        </div>

                        <div class="col-span-8 mx-4">
                            <h5 class="block text-base font-medium text-gray-900">{{ moduleData.meta.name }}</h5>
                            <span class="block text-sm text-gray-500">{{ moduleData.meta.intro }}</span>
                        </div>

                        <i class="flex items-center justify-center col-span-1 far fa-chevron-right"></i>

                    </div>

                </a>

            </div>

            <div class="w-2/3 pl-10">

                <div v-if="!currentModule" class="flex items-center justify-center py-5 mx-auto my-5 text-gray-400">

                    <i class="mr-2 text-2xl fal fa-hand-point-left"></i>
                    <span>Kies links een module.</span>

                </div>

                <div v-else class="flex flex-col w-full h-full px-4 py-5 overflow-auto">

                    <h2 class="text-2xl font-bold text-gray-900">{{ currentModule.meta.name }}</h2>
                    <div class="text-gray-700 text-md" v-html="currentModule.meta.description"></div>

                    <div class="pt-5 mt-auto row">

                        <div class="text-center text-muted col-9" v-if="!websitePage">
                            <i class="mr-2 fa fa-exclamation-triangle"></i>
                            <span>
                                De pagina dient eerst aangemaakt te zijn alvorens content toegevoegd kan worden.<br/>
                                Klik bovenaan op "Opslaan" om hier verder te kunnen.
                            </span>
                        </div>

                        <div class="text-right" :class="!websitePage ? 'col-3' : 'col-12'">
                            <button class="ml-auto btn btn-success" @click="addCurrentModule"
                                    :disabled="!websitePage">
                                Kies deze module
                                <i class="ml-2 far fa-arrow-right"></i>
                            </button>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import Toolbar from './Toolbar';

export default {

    components: {
        Toolbar,
    },

    props: {
        websitePage: Object,
        modulesData: Object,
    },

    data() {
        return {
            currentModuleId: null,
        };
    },

    mounted() {
    },

    methods: {

        onModuleClick($event, moduleId) {
            // Set
            this.currentModuleId = moduleId;

            // Avoid browser navigating.
            event.preventDefault();

            return false;
        },

        addCurrentModule() {
            this.$emit('moduleChoosed', this.currentModuleId);
        }
    },

    computed: {

        currentModule() {
            return this.modulesData[this.currentModuleId];
        }

    }

}

</script>

<style lang="scss" scoped>

.website\:\:admin-websitePages-createEdit-moduleEditor-Gallery {

    .selector {
        a.active {
            @apply bg-indigo-50 border-indigo-200 z-10;

            h5 {
                @apply text-indigo-900;
            }

            span {
                @apply text-indigo-700;
            }
        }
    }
}

</style>
